import storeRoot from "./store-root";
import account from "./modules/account";
import pond from "./modules/pond";
import cultureCycle from "./modules/cultureCycle";
import user from "./modules/user";
import fryPurchase from "./modules/fryPurchase";
import fish from "./modules/fish";
import fishSales from "./modules/fishSales";
import fishLoss from "./modules/fishLoss";
import turnPond from "./modules/turnPond";
import proofing from "./modules/proofing";
import feeding from "./modules/feeding";
import prevent from "./modules/prevent";
import manure from "./modules/manure";
import base from "./modules/base";
import provider from "./modules/provider";
import customer from "./modules/customer";
import dataDict from "./modules/dataDict";
import report from "./modules/report";
import area from "./modules/area";
import storeHouse from "./modules/storeHouse";
import expense from "./modules/expense";
import permission from "./modules/permission";
import waterQualityParameter from "./modules/waterQualityParameter";
import homeReport from "./modules/homeReport";
import qualityCheck from "./modules/qualityCheck";
import driverManage from "./modules/driverManage";
import circulationBusiness from "./modules/circulationBusiness";
import qualityTracing from "./modules/qualityTracing";
import productionPlan from "./modules/productionPlan";
import cultureBreed from "./modules/cultureBreed";
import materialSetting from "./modules/materialSetting";
import materialPurchase from "./modules/materialPurchase";
import personManagement from "./modules/personManagement";
import userManage from "./modules/userManage";
import roleSetting from "./modules/roleSetting";
import inOutReport from "./modules/inOutReport";
import inOutRank from "./modules/inOutRank";
import costOriginValue from "./modules/costOriginValue";
import alarm from "./modules/alarm";
import auditOrder from "./modules/auditOrder";
var storeInterface = storeRoot;
var modulesInterface = {
  account,
  pond,
  cultureCycle,
  user,
  fryPurchase,
  fish,
  fishSales,
  fishLoss,
  turnPond,
  proofing,
  feeding,
  prevent,
  manure,
  base,
  provider,
  customer,
  dataDict,
  report,
  area,
  storeHouse,
  expense,
  waterQualityParameter,
  permission,
  homeReport,
  qualityCheck,
  driverManage,
  circulationBusiness,
  qualityTracing,
  productionPlan,
  cultureBreed,
  materialSetting,
  materialPurchase,
  personManagement,
  userManage,
  roleSetting,
  inOutReport,
  inOutRank,
  costOriginValue,
  alarm,
  auditOrder,
};

export var store = storeInterface;
export var modules = modulesInterface;
